import React, { useState, useEffect } from 'react';
import { Select, Button, Card, Descriptions, Tag, message, Spin, Alert } from 'antd';
import { UserOutlined, PhoneOutlined, WechatOutlined, SaveOutlined } from '@ant-design/icons';
import axios from 'axios';
import AuthService from '../../utils/auth';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3060/api';

const StepGuideAssignment = ({ tour, completeness, onRefresh }) => {
  const [staffList, setStaffList] = useState([]);
  const [selectedGuideId, setSelectedGuideId] = useState(tour?.guideId || null);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStaffList();
  }, []);

  useEffect(() => {
    setSelectedGuideId(tour?.guideId || null);
  }, [tour?.guideId]);

  const fetchStaffList = async () => {
    try {
      const res = await axios.get(`${API_BASE}/salespersons`, {
        headers: AuthService.getAuthHeaders()
      });
      if (res.data.success) {
        // 只显示导游身份的员工
        const guides = (res.data.data || []).filter(s => s.role === 'guide');
        setStaffList(guides);
      }
    } catch (err) {
      message.error('获取员工列表失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      await axios.put(
        `${API_BASE}/tours/${tour.id}/guide`,
        { guideId: selectedGuideId },
        { headers: AuthService.getAuthHeaders() }
      );
      message.success('导游分配已保存');
      await onRefresh();
    } catch (err) {
      message.error('保存失败: ' + (err.response?.data?.error || err.message));
    } finally {
      setSaving(false);
    }
  };

  const selectedGuide = staffList.find(s => s.id === selectedGuideId);
  const hasGuide = completeness?.tour?.hasGuide;

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 40 }}>
        <Spin tip="加载员工列表..." />
      </div>
    );
  }

  return (
    <div>
      {hasGuide ? (
        <Alert
          type="success"
          message="导游已分配"
          showIcon
          style={{ marginBottom: 16 }}
        />
      ) : (
        <Alert
          type="warning"
          message="请为本产品分配导游"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      <Card title="选择导游" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 16 }}>
          <Select
            style={{ flex: 1, maxWidth: 400 }}
            placeholder="请选择导游"
            value={selectedGuideId}
            onChange={(val) => setSelectedGuideId(val)}
            allowClear
            showSearch
            optionFilterProp="label"
            options={staffList.map(s => ({
              value: s.id,
              label: s.name,
            }))}
          />
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={handleSave}
            loading={saving}
          >
            保存
          </Button>
        </div>

        {selectedGuide && (
          <Card type="inner" title="导游信息" size="small">
            <Descriptions column={{ xs: 1, sm: 3 }} size="small">
              <Descriptions.Item label={<><UserOutlined /> 姓名</>}>
                {selectedGuide.name}
              </Descriptions.Item>
              <Descriptions.Item label={<><PhoneOutlined /> 电话</>}>
                {selectedGuide.phone || '-'}
              </Descriptions.Item>
              <Descriptions.Item label={<><WechatOutlined /> 微信</>}>
                {selectedGuide.wechat || '-'}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        )}
      </Card>
    </div>
  );
};

export default StepGuideAssignment;
